import { useSelector } from "react-redux";
import AdminCommonRepository from "src/repository/Admin/AdminCommonRepository";
import { getRoleList, getOrgList } from "src/store/slice/model/Admin/AdminCommon";
import store from "src/storeWire";
import { isEqual } from "underscore";

export function useAdminCommonStore() {
    const roleList = useSelector((state) => state.entities.model_Admin_Common.roleList, isEqual)
    const orgList = useSelector((state) => state.entities.model_Admin_Common.orgList, isEqual)


    let data = {
        roleList,
        orgList
    };

    let fetch = {
        get_role_list: async () => {
            return await store.dispatch(getRoleList())
        },
        get_organization_detail: async () => {
            return await store.dispatch(getOrgList())
        },
        fetch_bom_Management_list: async (params) => {
            return await new AdminCommonRepository().fetchBomManagementList(params);
        },
        fetch_compliance_Management_list: async (params) => {
            return await new AdminCommonRepository().fetchComplianceManagementList(params);
        },

        export_compliance_Survey: async (params) => {
            return await new AdminCommonRepository().exportComplianceManagementSurvey(params);
        },

        fetch_bom_Details_Management_list: async (params) => {
            return await new AdminCommonRepository().fetchBomDetailsManagementList(params);
        },

    };
    let set = {

    };
    return [data, fetch, set]
}